import { MutationCache, QueryCache, QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { SnackbarProvider, enqueueSnackbar } from "notistack";
import "./App.css";
import Router from "./routes";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 2,
      staleTime: 0,
    },
  },
  queryCache: new QueryCache({
    onError: (error) => {
      enqueueSnackbar(error?.message || "Something went wrong", {
        variant: "error",
      });
    },
  }),
  mutationCache: new MutationCache({
    onError: (error) => {
      enqueueSnackbar(error?.message || "Something went wrong", {
        variant: "error",
      });
    },
  }),
});

function App() {
  return (
    <SnackbarProvider maxSnack={3} anchorOrigin={{ vertical: "top", horizontal: "right" }}>
      <QueryClientProvider client={queryClient}>
        <Router />
      </QueryClientProvider>
    </SnackbarProvider>
  );
}

export default App;
